// CMS runtime layer. On boot the public site asks the CMS backend for the
// latest published content snapshot. If the CMS is unreachable (e.g. pure
// static hosting), the site renders the bundled default content — identical
// to the approved website.

let published = null;

export async function bootCms() {
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 2500);
    const res = await fetch("/api/content/published.json", {
      signal: ctrl.signal,
      cache: "no-store",
    });
    clearTimeout(timer);
    if (res.ok) published = await res.json();
  } catch {
    published = null;
  }
}

export const getCms = () => published;
